import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './ABTestingCalculator.css';
import * as math from 'mathjs';
import { Gaussian } from 'ts-gaussian';

interface CalculatorProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const Calculator: React.FC<CalculatorProps> = ({ isOpen, onRequestClose }) => {
  const [visitorsA, setVisitorsA] = useState(50000);
  const [conversionsA, setConversionsA] = useState(500);
  const [visitorsB, setVisitorsB] = useState(50000);
  const [conversionsB, setConversionsB] = useState(500);
  const [confidence, setConfidence] = useState(95);
  const [isSignificant, setIsSignificant] = useState(false);
  const [result, setResult] = useState<{ header: string; message: string; pValue: number;}>({
    header: 'Result not significant!',
    message: 'Variant B\'s conversion rate (1.00%) is not significantly different from variant A\'s conversion rate (1.00%)',
    pValue: 0.5,
  });

  const handleCalculate = () => {
    const pA = conversionsA / visitorsA;
    const pB = conversionsB / visitorsB;
    const pPool = (conversionsA + conversionsB) / (visitorsA + visitorsB);

    // Pooled standard error
    const sePooled = Math.sqrt(pPool * (1 - pPool) * (1 / visitorsA + 1 / visitorsB));

    // Z-score for the difference
    const zScore = (pB - pA) / sePooled;

    const distribution = new Gaussian(0, 1); // Standard normal distribution
    const pValue = 2 * (1 - distribution.cdf(math.abs(zScore)));
    const alpha = (100 - confidence) / 100;  // Significance level for a two-tailed test
    const significant = pValue < alpha;
    setIsSignificant(significant)
    const header = significant ? 'Result is significant!' : `Result not significant!`

    // const message = significant
    //     ? `Variant B's conversion rate (${(pB * 100).toFixed(2)}%) is significantly different from variant A's conversion rate (${(pA * 100).toFixed(2)}%)`
    //     : `Variant B's conversion rate (${(pB * 100).toFixed(2)}%) is not significantly different from variant A's conversion rate (${(pA * 100).toFixed(2)}%)`;
    //   setResult({ header, message, pValue });
    // };
    var message_det = ''
    var message_det1 = ''

    if ((pB * 100) > (pA * 100)) {message_det = 'higher'} else {message_det = 'lower'}
    if ((pB * 100) > (pA * 100)) {message_det1 = 'better'} else {message_det1 = 'worser'}
    var message_det_diff = (pB - pA) 
    if (message_det_diff == 0) {message_det_diff = 1} else {message_det_diff = math.abs(message_det_diff) * 100}

    const message = significant
      ? `Variant B's conversion rate (${(pB * 100).toFixed(2)}%) was ${message_det} than variant A's conversion rate (${(pA * 100).toFixed(2)}%). You can be (${(message_det_diff * 100).toFixed(2)}%) confident that variant B will perform ${message_det1} than variant A`
      : `Variant B's conversion rate (${(pB * 100).toFixed(2)}%) was not ${message_det} than variant A's conversion rate (${(pA * 100).toFixed(2)}%). You can be (${(message_det_diff * 100).toFixed(2)}%) confident that variant B will not perform ${message_det1} than variant A`;
    setResult({ header, message, pValue });
  };

  useEffect(() => {
  }, [isSignificant, result]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="feasibility-modal"
      overlayClassName="feasibility-overlay"
    >
      <div className="modal-header-fc">
        <button onClick={onRequestClose} className="close-button">&times;</button>
      </div>
      <div className="calculator-container">
        <h2>Calculate Statistical Significance</h2>

        <div className="groups-container">
          {/* Group A */}
          <div className="group">
            <h3>A</h3>
            <label>
              Volume
              <input
                type="number"
                value={visitorsA}
                onChange={(e) => setVisitorsA(parseInt(e.target.value))}
                style={{marginLeft:10}}
              />
            </label>
            <label>
              Conversions (Clicks, QVs etc)
              <input
                type="number"
                value={conversionsA}
                onChange={(e) => setConversionsA(parseInt(e.target.value))}
                style={{marginLeft:10}}
              />
            </label>
            <label style={{marginBottom:0,}}>Conversion rate: {(conversionsA / visitorsA * 100).toFixed(2)}%</label>
          </div>

          {/* Group B */}
          <div className="group group-b" style={{backgroundColor: isSignificant? "#229954" : "#05467E"}}>
            <h3>B</h3>
            <label style={{fontWeight:'bold', textAlign:'center'}}>
            Volume
              <input
                type="number"
                value={visitorsB}
                onChange={(e) => setVisitorsB(parseInt(e.target.value))}
                style={{backgroundColor: isSignificant? "#229954" : "#05467E"}}
              />
            </label>
            <label>
              Conversions (Clicks, QVs etc)
              <input
                type="number"
                value={conversionsB}
                onChange={(e) => setConversionsB(parseInt(e.target.value))}
                style={{backgroundColor: isSignificant? "#229954" : "#05467E"}}
              />
            </label>
            <label style={{marginBottom:0,}}>Conversion rate: {(conversionsB / visitorsB * 100).toFixed(2)}%</label>
          </div>
        </div>

        <div className="options-container">
          {/* Confidence */}
          <div className="option">
            <h4>Confidence</h4>
            <div style={{display:'flex', justifyContent:'normal'}}>

            <label>
              <input
                type="radio"
                value="90"
                checked={confidence === 90}
                onChange={() => setConfidence(90)}
              />
              90%
            </label>
            <label style={{marginLeft:15}}>
              <input
                type="radio"
                value="95"
                checked={confidence === 95}
                onChange={() => setConfidence(95)}
              />
              95%
            </label>
            <label style={{marginLeft:15}}>
              <input
                type="radio"
                value="99"
                checked={confidence === 99}
                onChange={() => setConfidence(99)}
              />
              99%
            </label>
            </div>
          </div>
        </div>

        <button onClick={handleCalculate} className="calculate-button">
          Calculate
        </button>

        {/* Placeholder for result */}
        <div className="result-container">
          <h3 style={{marginBottom:10, marginTop:10, color: isSignificant? "green" : "#05467E"}}>{result.header}</h3>
          <p style={{marginTop:0}}>{result.message}</p>
          <p>p-value: {result.pValue.toFixed(4)}</p>
        </div>
      </div>
    </Modal>
  );
};

export default Calculator;